import React from "react";
import { useI18n } from "@/lib/i18n";
import { Languages } from "lucide-react";

export default function LangToggle({ compact = false }) {
  const { lang, toggle } = useI18n();
  return (
    <button
      onClick={toggle}
      data-testid="lang-toggle-button"
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 hover:border-orange-500/50 hover:text-orange-400 transition-colors text-sm font-semibold"
    >
      <Languages className="w-4 h-4" />
      {compact ? (lang === "en" ? "اردو" : "EN") : lang === "en" ? "English / اردو" : "اردو / English"}
    </button>
  );
}
